import { XPathComponent } from './components/advanced/xpath/xpath.component';
import { DecoratorDirective } from './directives/decorator.directive';

// Import this barrel via a relative path to avoid Angular NG3004.

export const XPath = [
  XPathComponent,
  DecoratorDirective
];
